import './Main.css';
import React from "react";
import {Flex} from "antd";
import {ContactForm} from "./ContactForm";

const translations = {
    en: {
        title: "Creative board game design",
        desc: "We design modern tabletop experiences with strong identity, clean visuals, and memorable gameplay presence.",
        cta1: "Explore projects",
        cta2: "About",
        studio: "Our studio",
        contact: "Contact",
        send: "Send",
        sending: "Sending...",
        name: "Name",
        email: "Email",
        message: "Message",
        success: "Your message has been sent.",
        submitError: "Something went wrong. Please try again.",
        errors: {
            nameRequired: "Name is required",
            emailRequired: "Email is required",
            emailInvalid: "Enter a valid email",
            messageRequired: "Message is required",
            messageShort: "Message should be at least 10 characters",
        },
        successTitle: "Message sent",
        successDesc: "Thanks! We’ll get back to you soon.",
    },
    ru: {
        title: "Дизайн настольных игр",
        desc: "Мы создаем современные настольные игры с сильной визуальной айдентикой и запоминающимся игровым опытом.",
        cta1: "Проекты",
        cta2: "О нас",
        studio: "Наша студия",
        contact: "Контакт",
        send: "Отправить",
        sending: "Отправка...",
        name: "Имя",
        email: "Email",
        message: "Сообщение",
        success: "Ваше сообщение отправлено.",
        submitError: "Что-то пошло не так. Попробуйте еще раз.",
        errors: {
            nameRequired: "Введите имя",
            emailRequired: "Введите email",
            emailInvalid: "Введите корректный email",
            messageRequired: "Введите сообщение",
            messageShort: "Сообщение должно быть не короче 10 символов",
        },
        successTitle: "Сообщение отправлено",
        successDesc: "Спасибо! Мы скоро свяжемся с вами.",
    },
    he: {
        title: "סטודיו לעיצוב משחקי קופסה",
        desc: "אנו מעצבים חוויות משחק מודרניות עם זהות חזותית חזקה וחוויית משחק זכירה.",
        cta1: "פרויקטים",
        cta2: "אודות",
        studio: "הסטודיו שלנו",
        contact: "צור קשר",
        send: "שלח",
        sending: "שולח...",
        name: "שם",
        email: "אימייל",
        message: "הודעה",
        success: "ההודעה נשלחה בהצלחה.",
        submitError: "משהו השתבש. נסו שוב.",
        errors: {
            nameRequired: "יש להזין שם",
            emailRequired: "יש להזין אימייל",
            emailInvalid: "יש להזין אימייל תקין",
            messageRequired: "יש להזין הודעה",
            messageShort: "ההודעה חייבת להכיל לפחות 10 תווים",
        },
        successTitle: "ההודעה נשלחה",
        successDesc: "תודה! נחזור אליך בקרוב.",
    }
};

export function Main() {
    const navItems = ["Home", "Catalog", "Studios", "Contact"];
    const getLangFromUrl = () => {
        const parts = window.location.pathname.split("/");
        return parts[1] || "en";
    };

    const [contactOpen, setContactOpen] = React.useState(false);
    const [contactSuccess, setContactSuccess] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const lang = getLangFromUrl();
    // @ts-ignore
    const t = translations[lang] || translations.en;

    const changeLang = (l: any) => {
        const base = window.location.origin;
        window.location.href = `${base}/${l}/`;
    };

    React.useEffect(() => {
        document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
    }, [lang]);
    return (
        <>
            <div className="page">
                <div className="shell">
                    <header className="header">
                        <div className="brand">
                            <div className="brand-mark">
                                <img src={"/logo_white.png"} alt="UGAR STUDIO logo"/>
                            </div>
                            <div>
                                <div className="brand-title" style={{letterSpacing: 0, color: "#444444"}}>
                                    <div style={{fontSize: 18}}>UGAR</div>
                                    <div>STUDIO</div>
                                </div>
                                {/*<p className="brand-subtitle">Board game design studio</p>*/}
                            </div>
                        </div>
                        <Flex gap={10} align={'center'} dir={lang === 'he' ? 'rtl' : 'ltr'}>
                            <div className={`lang ${open ? 'open' : ''}`}>
                                <button className="lang-btn" onClick={() => setOpen(!open)}
                                        style={{whiteSpace: 'nowrap'}}>
                                    {lang.toUpperCase()} ▾
                                </button>
                                <div className="lang-menu">
                                    <button onClick={() => changeLang('en')}>English</button>
                                    <button onClick={() => changeLang('he')}>עברית</button>
                                    <button onClick={() => changeLang('ru')}>Русский</button>
                                </div>
                            </div>
                            <button className="button button-contact" onClick={
                                () => setContactOpen(true)
                            }>{t.contact}</button>
                        </Flex>
                    </header>

                    <section className="hero">
                        <div className="hero-copy">

                            <div className="eyebrow"
                                 style={{color: '#94a3b8', textTransform: 'uppercase'}}>{t.studio}</div>
                            <h1 className="headline">{t.title}</h1>
                            <p className="description" style={{color: '#64748b'}}>{t.desc}</p>

                            <div className="actions">
                                <button className="button button-primary" onClick={
                                    () => {
                                        const host = window.location.hostname.replace('www.', '');
                                        window.location.href = `https://games.${host}/${lang}/`
                                        }
                                }>{t.cta1}</button>
                                {/*<button className="button button-secondary">{t.cta2}</button>*/}
                            </div>
                        </div>

                        <div className="hero-visual">
                            <img src={"/img.png"} alt="Board game components in isometric view"/>
                        </div>
                    </section>
                </div>
            </div>
            {contactOpen && (
                <div className="modal-overlay" onClick={() => {
                    setContactOpen(false);
                    setContactSuccess(false);
                }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        {!contactSuccess ? (
                            <>
                                <Flex  style={{marginBottom : 20}} justify={'space-between'} align={'center'} dir={lang === 'he' ? "rtl" : 'ltr'}>
                                    <h2 style={{margin : 0}}>{t.contact}</h2>
                                    <div className="lang-btn"
                                            style={{width: 32, height: 32, padding: 8}}
                                        onClick={() => {
                                        setContactOpen(false);
                                        setContactSuccess(false);
                                    }}>

                                    <svg


                                        width="16" height="16" viewBox="0 0 24 24">
                                        <path
                                            d="M6 6L18 18M18 6L6 18"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            fill="none"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    </div>
                                </Flex>
                                <ContactForm
                                    t={t}
                                    onSubmitSuccess={() => setContactSuccess(true)}
                                />
                            </>
                        ) : (
                            <div className="success-state">
                                <Flex style={{marginBottom : 20}} justify={'space-between'} align={'center'} dir={lang === 'he' ? "rtl" : 'ltr'}>
                                    <h2 style={{margin : 0}}>{t.successTitle}</h2>
                                    <div className="lang-btn"
                                         style={{width: 32, height: 32, padding: 8}}
                                         onClick={() => {
                                             setContactOpen(false);
                                             setContactSuccess(false);
                                         }}>
                                        <svg
                                            width="24" height="24" viewBox="0 0 24 24">
                                            <path
                                                d="M6 6L18 18M18 6L6 18"
                                                stroke="#000000"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </div>
                                </Flex>
                                <p>{t.successDesc}</p>

                                <button
                                    className="button button-primary"
                                    onClick={() => {
                                        setContactOpen(false);
                                        setContactSuccess(false);
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            )}
        </>
    );
}
